// Polyfills for Draft.js compatibility

if (typeof global === "undefined") {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(window as any).global = window;
}

if (typeof process === "undefined") {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(window as any).process = { env: {} };
}

// Additional polyfills for Draft.js

if (typeof setImmediate === "undefined") {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(window as any).setImmediate = (callback: (...args: any[]) => void, ...args: any[]) => {
		return setTimeout(callback, 0, ...args);
	};
}

if (typeof clearImmediate === "undefined") {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(window as any).clearImmediate = (id: number) => {
		clearTimeout(id);
	};
}
